import request from '@/utils/request'

// 查询列表
export function apiTSysCompanySubjectList (query) {
  return request({
    url: '/mdm/tSysCompanySubject/list',
    method: 'get',
    params: query
  })
}
